import * as Storage from 'utils/local-storage'

export const AssessmentTypes = {
    MultipleChoice: 'MULTIPLE_CHOICE',
    FillInCode: 'FILL_IN_CODE',
    ExecutableCode: 'EXECUTABLE_CODE',
}

export const checkQuizResults = async (): Promise<undefined | string | null> => {
    if (typeof window !== 'undefined') {
        const response = await Storage.get(Storage.Keys.QuizResults)
        const quizId = response !== null ? (response as string) : null
        return quizId
    }
    return undefined
}

export const saveQuizResults = async (value: string) => {
    if (typeof window !== 'undefined') {
        const response = await Storage.set(Storage.Keys.QuizResults, value)
        return response
    }
}
